if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.loadToken = 0;
        this.ensureQuickViewStyles();
      }

      ensureQuickViewStyles() {
        if (document.getElementById('NNQuickViewProductInfoStyles')) return;
        const style = document.createElement('style');
        style.id = 'NNQuickViewProductInfoStyles';
        style.textContent = `
          .nn-quick-view .quick-add-modal__content{max-width:1280px;width:min(94vw,1280px)}
          .nn-quick-view .quick-add-modal__content-info{padding:2.4rem 2.6rem 2.8rem}
          .nn-quick-view .nnv4-pdp{--nnv4-pt:0px!important;--nnv4-pb:0px!important;background:#fff}
          .nn-quick-view .nnv4-pdp__frame,.nn-quick-view .nnv4-pdp__frame--full{width:100%;max-width:none;padding-inline:0}
          .nn-quick-view .nnv4-pdp__layout{grid-template-columns:minmax(0,1.06fr) minmax(32rem,.94fr);gap:3.2rem}
          .nn-quick-view .nnv4-pdp__gallery-wrap--sticky{position:static;top:auto}
          .nn-quick-view .nnv4-pdp__current-path{display:none!important}
          .nn-quick-view .nnv4-pdp__thumbs{max-height:54rem}
          .nn-quick-view .nnv4-pdp__block+.nnv4-pdp__block{margin-top:1.55rem}
          .nn-quick-view .nnv4-pdp__variants{padding-top:1.55rem}
          .nn-quick-view .nnv4-pdp__option{margin-bottom:1.45rem}
          .nn-quick-view .nnv4-pdp__lightbox{z-index:10020}
          .nn-quick-view .nn-qv__details-wrap{margin-top:1.8rem;padding-top:1.5rem;border-top:1px solid var(--nnv4-line,#e0e4e7)}
          .nn-quick-view .nn-qv__details-link{display:inline-flex;align-items:center;gap:.8rem;padding-bottom:.35rem;border-bottom:1px solid currentColor;color:var(--nnv4-heading,#223b57);font-size:1.2rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase;text-decoration:none;transition:gap .2s ease,opacity .2s ease}
          .nn-quick-view .nn-qv__details-link:hover{gap:1.05rem;opacity:.72}
          .nn-quick-view .nn-qv__details-link svg{width:1.7rem;height:1.7rem;flex:0 0 auto}
          @media(max-width:989px){
            .nn-quick-view .quick-add-modal__content{width:min(94vw,760px)}
            .nn-quick-view .nnv4-pdp__layout{grid-template-columns:1fr;gap:2.4rem}
          }
          @media(max-width:749px){
            .nn-quick-view .quick-add-modal__content{width:calc(100vw - 2rem)}
            .nn-quick-view .quick-add-modal__content-info{padding:1.4rem}
            .nn-quick-view .nnv4-pdp__frame,.nn-quick-view .nnv4-pdp__frame--full{padding-inline:0!important}
          }
        `;
        document.head.appendChild(style);
      }

      hide(preventFocus = false) {
        this.loadToken += 1;
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        const pageUrl = opener.getAttribute('data-product-url');
        if (!pageUrl) return;

        const token = ++this.loadToken;
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner')?.classList.remove('hidden');

        const requestUrl = new URL(pageUrl, window.location.origin);
        const cardVariantId = opener
          .closest('.nn-product-card')
          ?.querySelector('[data-nn-variant-input]')
          ?.value;
        if (cardVariantId) requestUrl.searchParams.set('variant', cardVariantId);

        fetch(requestUrl.toString(), {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'text/html',
          },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Quick view request failed: ${response.status}`);
            return response.text();
          })
          .then((responseText) => {
            if (token !== this.loadToken) return;
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceRoot = responseHTML.querySelector('.nnv4-pdp[id^="nnv4-pdp-"]');
            if (!sourceRoot) throw new Error('Product information section was not found');

            const sourceSectionId = sourceRoot.id.replace(/^nnv4-pdp-/, '');
            const uniqueSectionId = `${sourceSectionId}-quick-${Date.now().toString(36)}`;
            const wrapper = sourceRoot.closest('[id^="shopify-section-"]');
            let fragmentHTML = wrapper ? wrapper.innerHTML : sourceRoot.outerHTML;

            if (!wrapper) {
              let sibling = sourceRoot.nextElementSibling;
              while (sibling && (sibling.tagName === 'STYLE' || sibling.tagName === 'SCRIPT')) {
                fragmentHTML += sibling.outerHTML;
                sibling = sibling.nextElementSibling;
              }
            }

            fragmentHTML = fragmentHTML.split(sourceSectionId).join(uniqueSectionId);
            this.modalContent.innerHTML = fragmentHTML;

            const quickRoot = this.modalContent.querySelector('.nnv4-pdp[id^="nnv4-pdp-"]');
            if (!quickRoot) throw new Error('Quick view product information could not be mounted');
            quickRoot.setAttribute('data-nnv4-quick-view', 'true');

            this.prepareQuickViewContent(quickRoot, pageUrl);
            this.activateProductInfoScript(quickRoot);
            this.bindQuickViewProductForm(quickRoot);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .catch((error) => {
            console.error(error);
            window.location.href = pageUrl;
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      prepareQuickViewContent(root, pageUrl) {
        root.querySelector('.nnv4-pdp__current-path')?.remove();
        root.querySelectorAll('.nnv4-pdp__block--app').forEach((node) => node.remove());

        const info = root.querySelector('.nnv4-pdp__info');
        if (!info) return;

        Array.from(info.children).forEach((child) => {
          const keep = child.matches(
            '.nnv4-pdp__block--title, .nnv4-pdp__block--price, .nnv4-pdp__variants, .nnv4-pdp__purchase'
          );
          if (!keep) child.remove();
        });

        const purchase = info.querySelector('.nnv4-pdp__purchase');
        if (!purchase || info.querySelector('.nn-qv__details-wrap')) return;

        const details = document.createElement('div');
        details.className = 'nn-qv__details-wrap';
        details.innerHTML = `
          <a class="nn-qv__details-link" href="${pageUrl}">
            <span>View Details</span>
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M5 12h13M14 7l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        `;
        purchase.insertAdjacentElement('afterend', details);
      }

      activateProductInfoScript(root) {
        const scripts = Array.from(this.modalContent.querySelectorAll('script'));
        const sectionScript = scripts.find((script) =>
          !script.src && script.textContent.includes('data-nnv4-ready')
        );
        if (!sectionScript) return;

        let code = sectionScript.textContent;
        const historyCode = "try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString())}catch(e){}";
        if (code.includes(historyCode)) {
          code = code.replace(historyCode, `if(!root.hasAttribute('data-nnv4-quick-view')){${historyCode}}`);
        }

        const activeScript = document.createElement('script');
        activeScript.textContent = code;
        sectionScript.replaceWith(activeScript);
      }

      bindQuickViewProductForm(root) {
        const form = root.querySelector('.nnv4-pdp__form');
        if (!form || form.dataset.nnQuickViewBound === '1') return;
        form.dataset.nnQuickViewBound = '1';

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const submitButton = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[data-nnv4-add]');
          if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');

          const formData = new FormData(form);
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const config = typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : { method: 'POST', headers: { Accept: 'application/json' } };

          config.headers = config.headers || {};
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          if (cart) {
            formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(window.routes?.cart_add_url || '/cart/add.js', config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) throw new Error(response.description || response.message || 'Unable to add this item.');
              if (!cart) {
                window.location.href = window.routes?.cart_url || '/cart';
                return;
              }

              document.body.addEventListener(
                'modalClosed',
                () => setTimeout(() => cart.renderContents(response)),
                { once: true }
              );
              this.hide(true);
            })
            .catch((error) => {
              console.error(error);
              submitButton.removeAttribute('aria-disabled');
            })
            .finally(() => {
              submitButton.classList.remove('loading');
              if (!submitButton.disabled) submitButton.removeAttribute('aria-disabled');
            });
        });
      }
    }
  );
}
